import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './LandingPage.css';

const LandingPage = () => {
    return (
        <div className="landing-container">
            <Navbar />

            <header className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">
                        <span className="line1">Enterprise-Grade APIs:</span>
                        <span className="line2">Authorization & Quota Enforcement</span>
                    </h1>
                    <p className="hero-subtitle">
                        Productionize your application with <strong>KYUBURN</strong>'s customizable solution for authorization and quota enforcement. Deploy a universal OAuth 2.0 Authorization Server for fine-grained security, and enforce strict usage quotas with our real-time Bouncer, engineered for enterprise scale.
                    </p>
                    <div className="hero-buttons">
                        <Link to="/login">
                            <button className="cta-button primary">Integrate Free</button>
                        </Link>
                        <button className="cta-button secondary">Read Documentation</button>
                    </div>
                </div>
                <div className="hero-visual">
                    <div className="hero-logo-container">
                        <img src="/logo.png" alt="KYUBURN Logo" className="hero-logo" />
                    </div>
                    <div className="floating-card card-1">
                        <div className="card-icon">🔐</div>
                        <div className="card-text">KYUBURN Auth</div>
                    </div>
                    <div className="floating-card card-2">
                        <div className="card-icon">👮🏻‍♂️</div>
                        <div className="card-text">KYUBURN Bouncer</div>
                    </div>
                    <div className="glow-orb"></div>
                </div>
            </header>

            <section className="features-section">
                <h2 className="section-title">Built for Scalable Startups</h2>
                <div className="features-grid two-column">
                    <div className="feature-card">
                        <h3 className="feature-title">🔐 KYUBURN Auth</h3>
                        <h4 className="feature-subtitle">Universal Authorization Service</h4>
                        <p className="feature-desc">
                            Deploy a dedicated <strong>OAuth 2.0 Authorization Server</strong> that interoperates with any Identity Provider (Azure AD, Okta, Auth0). Issue <strong>custom JWT access tokens</strong> enriched with fine-grained <strong>Roles and Permissions</strong>, enforcing centralized policy across your microservices and applications.
                        </p>
                    </div>
                    <div className="feature-card">
                        <h3 className="feature-title">👮🏻‍♂️ KYUBURN Bouncer</h3>
                        <h4 className="feature-subtitle">Usage Tracking & Quota Enforcement</h4>
                        <p className="feature-desc">
                            Track real-time usage for accurate billing while enforcing strict <strong>quota limits</strong>. The Bouncer automatically prevents overages by gating access when limits are reached, ensuring customers stay within their subscribed tiers and protecting your infrastructure.
                        </p>
                    </div>
                </div>
            </section>

            <section className="stats-section">
                <div className="stat-item">
                    <span className="stat-number">&lt;50ms</span>
                    <span className="stat-label">Auth Latency</span>
                </div>
                <div className="stat-item">
                    <span className="stat-number">10k+</span>
                    <span className="stat-label">Events/Sec</span>
                </div>
                <div className="stat-item">
                    <span className="stat-number">99.99%</span>
                    <span className="stat-label">Uptime SLA</span>
                </div>
            </section>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src="/logo.png" alt="KYUBURN Logo" className="footer-logo" />
                        <p>© 2025 KYUBURN Inc.</p>
                    </div>
                    <div className="footer-links">
                        <a href="#">API Docs</a>
                        <a href="#">Status</a>
                        <a href="#">Contact</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
